import { BaseEvents } from '@/shared/utils';
import { LessonProgresses } from './types/lessons';
import { ModalType } from './types/modals';

export const LearningPathByIdEventKeys = {
  customer: {
    view: 'customer/view',
  },
  summary: {
    view: 'summary/view',
  },
  lessons: {
    view: 'lessons/view',
  },
  lessonProgresses: {
    update: 'lessonProgresses/update',
    create: 'lessonProgresses/create',
  },
  favourites: {
    view: 'favourites/view',
    create: 'favourites/create',
    delete: 'favourites/delete',
  },
  modals: {
    videoModal: 'modals/video-modal',
    lessonCompletionModal: 'modals/lesson-completion-modal',
  },
  redirects: {
    to: 'redirects/to',
    back: 'redirects/back',
  },
} as const;

export interface LearningPathByIdEvents extends BaseEvents {
  'customer/view': { email: string };
  'summary/view': { learningPathDocumentId: string };
  'lessons/view': { learningPathDocumentId: string };
  'favourites/view': { learningPathDocumentId: string };
  'favourites/create': { learningPathDocumentId: string };
  'favourites/delete': { favouriteDocumentId: string };
  'modals/video-modal': ModalType | null;
  'modals/lesson-completion-modal': ModalType | null;
  'lessonProgresses/update': LessonProgresses;
  'lessonProgresses/create': LessonProgresses & { learningPathDocumentId?: string };
  'redirects/to': string;
  'redirects/back': void;
}
